import { json, postBiz, rows } from '../core/coreapi';
import {
  IDeterminantBudgetWorkbench,
  IReportTablePayload,
} from './determinantBudget.models';

export const fetchDeterminantBudgetWorkbench = async (
  determinantbudgetid: number,
  recommendationid?: number | null
): Promise<IDeterminantBudgetWorkbench> =>
  json(
    await postBiz({
      s: 'determinantbudget',
      a: 'workbench',
      rid: determinantbudgetid || null,
      rci: recommendationid || null,
    })
  );

export const initializeFromRecommendation = async (recommendationid: number) =>
  json(
    await postBiz({
      s: 'determinantbudget',
      a: 'initialize',
      rci: recommendationid,
    })
  );

export const recomputeCapacity = async (rid: number, stamp?: string) =>
  json(
    await postBiz({
      s: 'determinantbudget',
      a: 'recomputecapacity',
      rid,
      stp: stamp || null,
    })
  );

export const saveManagementAdjustment = async (p: {
  determinantbudgetid: number;
  adjustmenttype: string;
  amount: number;
  reason: string;
  authoritycode?: string;
  stamp?: string;
}) =>
  json(
    await postBiz({
      s: 'determinantbudget',
      a: 'adjust',
      rid: p.determinantbudgetid,
      typ: p.adjustmenttype,
      amt: Number(p.amount || 0),
      rsn: p.reason,
      ath: p.authoritycode || null,
      stp: p.stamp || null,
    })
  );

export const deleteManagementAdjustment = async (rid: number, stamp?: string) =>
  json(
    await postBiz({
      s: 'determinantbudget',
      a: 'deleteadjustment',
      rid,
      stp: stamp || null,
    })
  );

export const regenerateReportTables = async (
  rid: number,
  tablecodes?: string[]
) =>
  json(
    await postBiz({
      s: 'determinantbudget',
      a: 'regeneratetables',
      rid,
      tbs: tablecodes || [],
    })
  );

export const fetchReportTable = async (
  rid: number,
  tablecode: string,
  page = 0,
  pagesize = 100
): Promise<IReportTablePayload> =>
  json(
    await postBiz({
      s: 'determinantbudget',
      a: 'gettable',
      rid,
      tbc: tablecode,
      pos: page,
      plm: pagesize,
    })
  );

export const validateDeterminantBudget = async (rid: number) =>
  json(await postBiz({ 
    s: 'determinantbudget', 
    a: 'validate', 
    rid 
  }));

export const acceptDeterminantBudget = async (rid: number, notes = '') =>
  json(await postBiz({ 
    s: 'determinantbudget', 
    a: 'accept', 
    rid, 
    nts: notes 
  }));

export const returnDeterminantBudget = async (rid: number, reason: string) =>
  json(
    await postBiz({ 
      s: 'determinantbudget', 
      a: 'return', 
      rid, 
      rsn: reason 
    })
  );

export const releasePlanningCapacity = async (rid: number, notes = '') =>
  json(
    await postBiz({ 
      s: 'determinantbudget', 
      a: 'release', 
      rid, 
      nts: notes 
    })
  );

export const findValidationIssues = async (
  rid: number,
  page = 0,
  pagesize = 50
) =>
  rows(
    await postBiz({
      s: 'determinantbudget',
      a: 'issues',
      rid,
      pos: page,
      plm: pagesize,
    })
  );
